import { StudentDetailPage } from "@/pages/teacher/StudentDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/classrooms/$classroomId/students/$studentId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId, studentId } = Route.useParams();
  return <StudentDetailPage classroomId={classroomId} studentId={studentId} />;
}
